@if (loader) {
  <div class="mt-spinner-container">
    <loader></loader>
  </div>
}

<div class="ozonetel-call-widget" [class.expanded]="fullScreen" [class.collapsed]="!fullScreen"
  [class.on-call]="isOnCall" [class.idle]="!isOnCall" [class.sdk-manual-dial-open]="showSdkManualDial || showCubeManualDial || showCentroManualDial || showCubeTools || showCentroTools" cdkDrag>
  <!-- Header -->
  <div class="widget-header" [ngClass]="getStatusClass()">
    <div class="header-left">
      <span class="status-indicator" [class.pulse]="isOnCall || isCubeAgentRinging || isCubeConnecting || isCubeAutoTransferRouting"></span>
      <span class="status-text">{{ getStatusText() }}</span>
      @if (showCubeLoginRetry) {
        <button
          type="button"
          class="header-retry-btn"
          (click)="cubeForceLogin()"
          title="Retry Cube login"
          >
          <mat-icon>refresh</mat-icon>
          Retry
        </button>
      }
      @if (isCentroDialer) {
        <button
          type="button"
          class="header-retry-btn header-free-agent-btn header-icon-btn"
          [disabled]="centroFreeAgentLoading"
          (click)="centroFreeAgentAndRetry()"
          title="Free Agent"
          >
          <mat-icon>person_off</mat-icon>
        </button>
      }
      @if (isCentroDialer) {
        <button
          type="button"
          class="header-retry-btn header-mode-btn header-icon-btn"
          [class.active]="centroAutoMode"
          [disabled]="isOnCall || agentStatus === 'BUSY' || agentStatus === 'ONCALL' || !centroReady || centroWrapUpActive"
          (click)="toggleCentroAutoMode()"
          [title]="centroAutoMode ? 'Switch to Manual mode' : 'Switch to Auto mode'"
          >
          <mat-icon>{{ centroAutoMode ? 'autorenew' : 'pan_tool' }}</mat-icon>
        </button>
      }
    </div>
    <!-- <div class="header-right">
    <span class="agent-status-badge" [ngClass]="'status-' + agentStatus.toLowerCase()">
      {{ agentStatus }}
    </span>
    <button class="icon-btn collapse-btn" (click)="toggleCollpse()">
      <mat-icon>{{ fullScreen ? 'expand_more' : 'expand_less' }}</mat-icon>
    </button>
  </div> -->

  <div class="header-right">
    <label class="agent-status-toggle" [class.disabled]="isOnCall || agentStatus === 'BUSY' || ozonetelWrapUpActive || cubeWrapUpActive">
      <input type="checkbox" [checked]="agentStatus === 'IDLE'" [disabled]="isOnCall || agentStatus === 'BUSY' || ozonetelWrapUpActive || cubeWrapUpActive"
        (change)="toggleAgentStatus()" />
      <span class="toggle-slider">
        <span class="toggle-thumb">
          <mat-icon class="dialpad-icon">dialpad</mat-icon>
        </span>
      </span>
    </label>
    <img src="../../../../assets/icons/call_icon.svg" alt="call" class="header-calling-icon" />
  </div>

</div>

<!-- Body Toggle Button -->
@if (fullScreen) {
  <div class="body-toggle-container" [ngClass]="getStatusClass()">
    <button class="body-toggle-btn" (click)="toggleBody()">
      <mat-icon class="toggle-icon" [class.rotated]="!showBody">keyboard_arrow_down</mat-icon>
    </button>
  </div>
}

<!-- Expanded Content -->
@if (fullScreen) {
  <div class="widget-body" [class.hidden]="!showBody">
    @if (showCubeReconnectPanel) {
      <div class="cube-reconnect-panel">
        <mat-icon class="cube-reconnect-icon">wifi_off</mat-icon>
        <p class="cube-reconnect-title">Cube connection lost</p>
        <p class="cube-reconnect-msg">{{ cubeLoginErrorMessage }}</p>
        <button type="button" class="cube-reconnect-btn" (click)="cubeForceLogin()" [disabled]="loader">
          <mat-icon>refresh</mat-icon>
          Retry login
        </button>
      </div>
    }
    <!-- Call Info Section -->
    @if ((showCubeCallPanel || showCentroCallPanel || (inputObj.Status === 'Disconnected' && !showCentroDispositionPanel)) && !showCubeDispositionPanel && !showCentroDispositionPanel) {
      <div class="call-info-section">
        <div class="caller-avatar">
          <mat-icon>person</mat-icon>
        </div>
        <div class="caller-details">
          <p class="caller-name">{{ displayCallerName || '—' }}</p>
          <p class="caller-number">{{ inputObj.phoneNo || 'No Number' }}</p>
          @if (displayCallerLoanId) {
            <p class="caller-loan-id">ID: {{ displayCallerLoanId }}</p>
          }
          @if (isCubeAutoTransferRouting) {
            <p class="caller-transfer-hint">
              {{ cubeAutoTransferTargetLabel ? ('Transferring to ' + cubeAutoTransferTargetLabel + '...') : 'Transferring...' }}
            </p>
          }
          @if (showTimer && (inputObj.Status === 'CONNECTED' || inputObj.Status === 'CALLING')) {
            <div class="call-timer">
              <mat-icon>timer</mat-icon>
              <span>{{ timerMinutes }}:{{ timerSeconds < 10 ? '0' : '' }}{{ timerSeconds }}</span>
            </div>
          }
        </div>
      </div>
    }
    @if (showCubeDispositionPanel) {
      <div class="call-info-section">
        <div class="caller-avatar">
          <mat-icon>person</mat-icon>
        </div>
        <div class="caller-details">
          <p class="caller-name">{{ displayCallerName || '—' }}</p>
          <p class="caller-number">{{ inputObj.phoneNo || 'No Number' }}</p>
          @if (displayCallerLoanId) {
            <p class="caller-loan-id">ID: {{ displayCallerLoanId }}</p>
          }
        </div>
      </div>
    }
    <!--
    Ozonetel SDK wrap-up disposition panel (ACW).
    Visible when showOzonetelDispositionPanel: SDK ozonetel dialer + Disconnected + wrap-up active.
    Flow: DROP → enterOzonetelWrapUp → loadOzonetelDispositions → submitOzonetelDisposition (Dispose).
    Caller info above/beside this panel stays visible until disposition succeeds.
    -->
    @if (showOzonetelDispositionPanel) {
      <div class="ozonetel-disposition-panel">
        <div class="ozonetel-disposition-header">
          <span class="ozonetel-disposition-header-icon">
            <mat-icon>assignment</mat-icon>
          </span>
          <div class="ozonetel-disposition-header-text">
            <p class="ozonetel-disposition-title">Wrap-up disposition</p>
            <p class="ozonetel-disposition-subtitle">Complete before next call</p>
          </div>
          <p class="ozonetel-wrapup-elapsed">
            <mat-icon>timer</mat-icon>
            <span>{{ wrapUpElapsedDisplay }}</span>
          </p>
        </div>
        @if (ozonetelDispositionError) {
          <p class="ozonetel-disposition-error">{{ ozonetelDispositionError }}</p>
        }
        <div class="ozonetel-disposition-fields">
          <mat-form-field class="ozonetel-disposition-select" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Disposition</mat-label>
            <mat-select
              [(ngModel)]="selectedOzonetelDisposition"
              placeholder="Select"
              panelClass="ozonetel-disposition-select-panel"
              [disabled]="ozonetelDispositionLoading || ozonetelDispositions.length === 0"
              >
              @for (d of ozonetelDispositions; track d) {
                <mat-option [value]="d.reason">{{ d.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <!-- <input
          type="text"
          class="ozonetel-disposition-comment"
          [(ngModel)]="ozonetelDispositionComment"
          placeholder="Comment (optional)"
          [disabled]="ozonetelDispositionLoading"
          /> -->
        </div>
        <button
          type="button"
          class="ozonetel-disposition-submit"
          (click)="submitOzonetelDisposition()"
          [disabled]="!selectedOzonetelDisposition || ozonetelDispositionLoading"
          >
          <mat-icon>assignment_turned_in</mat-icon>
          <span>Dispose</span>
        </button>
      </div>
    }
    @if (showCubeDispositionPanel) {
      <div class="ozonetel-disposition-panel">
        <div class="ozonetel-disposition-header">
          <span class="ozonetel-disposition-header-icon">
            <mat-icon>assignment</mat-icon>
          </span>
          <div class="ozonetel-disposition-header-text">
            <p class="ozonetel-disposition-title">Wrap-up disposition</p>
            <p class="ozonetel-disposition-subtitle">Complete before next call</p>
          </div>
          <p class="ozonetel-wrapup-elapsed">
            <mat-icon>timer</mat-icon>
            <span>{{ wrapUpElapsedDisplay }}</span>
          </p>
        </div>
        @if (cubeDispositionError) {
          <p class="ozonetel-disposition-error">{{ cubeDispositionError }}</p>
        }
        <div class="ozonetel-disposition-fields">
          <mat-form-field class="ozonetel-disposition-select" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Disposition</mat-label>
            <mat-select
              [(ngModel)]="selectedCubeDisposition"
              placeholder="Select"
              panelClass="ozonetel-disposition-select-panel"
              [disabled]="cubeWrapUpSubmitInFlight"
              >
              @for (d of cubeDispositions; track d) {
                <mat-option [value]="d.reason">{{ d.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <button
          type="button"
          class="ozonetel-disposition-submit"
          (click)="submitCubeDisposition()"
          [disabled]="!selectedCubeDisposition || cubeWrapUpSubmitInFlight"
          >
          <mat-icon>assignment_turned_in</mat-icon>
          <span>Dispose</span>
        </button>
      </div>
    }
    @if (showCentroDispositionPanel) {
      <div class="call-info-section">
        <div class="caller-avatar">
          <mat-icon>person</mat-icon>
        </div>
        <div class="caller-details">
          <p class="caller-name">{{ displayCallerName || '—' }}</p>
          <p class="caller-number">{{ inputObj.phoneNo || 'No Number' }}</p>
          @if (displayCallerLoanId) {
            <p class="caller-loan-id">ID: {{ displayCallerLoanId }}</p>
          }
        </div>
      </div>
    }
    @if (showCentroDispositionPanel) {
      <div class="ozonetel-disposition-panel">
        <div class="ozonetel-disposition-header">
          <span class="ozonetel-disposition-header-icon">
            <mat-icon>assignment</mat-icon>
          </span>
          <div class="ozonetel-disposition-header-text">
            <p class="ozonetel-disposition-title">Centro wrap-up</p>
            <p class="ozonetel-disposition-subtitle">Complete before next call</p>
          </div>
          <p class="ozonetel-wrapup-elapsed">
            <mat-icon>timer</mat-icon>
            <span>{{ wrapUpElapsedDisplay }}</span>
          </p>
        </div>
        @if (centroDispositionError) {
          <p class="ozonetel-disposition-error">{{ centroDispositionError }}</p>
        }
        <div class="ozonetel-disposition-fields">
          <mat-form-field class="ozonetel-disposition-select" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Disposition</mat-label>
            <mat-select
              [(ngModel)]="selectedCentroDisposition"
              placeholder="Select"
              panelClass="ozonetel-disposition-select-panel"
              [disabled]="centroDispositionLoading || centroDispositions.length === 0"
              >
              @for (d of centroDispositions; track d) {
                <mat-option [value]="d.reason">{{ d.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <button
          type="button"
          class="ozonetel-disposition-submit"
          (click)="submitCentroDisposition()"
          [disabled]="!selectedCentroDisposition || centroDispositionLoading"
          >
          <mat-icon>assignment_turned_in</mat-icon>
          <span>Dispose</span>
        </button>
      </div>
    }
    <!-- Call Details Card -->
    <!-- <div class="call-details-card" *ngIf="isOnCall && showCubeCallDetailsCard && !showCubeDispositionPanel">
    <div class="detail-row" *ngIf="displayCallerName">
      <span class="detail-label">Customer</span>
      <span class="detail-value">{{ displayCallerName }}</span>
    </div>
    <div class="detail-row" *ngIf="inputObj.phoneNo">
      <span class="detail-label">Mobile</span>
      <span class="detail-value">{{ inputObj.phoneNo }}</span>
    </div>
    <div class="detail-row" *ngIf="displayCallerLoanId">
      <span class="detail-label">Loan ID</span>
      <span class="detail-value">{{ displayCallerLoanId }}</span>
    </div>
    <div class="detail-row" *ngIf="callData?.campaignName">
      <span class="detail-label">Campaign</span>
      <span class="detail-value">{{ callData.campaignName }}</span>
    </div>
    <div class="detail-row" *ngIf="callData?.ucid">
      <span class="detail-label">UCID</span>
      <span class="detail-value">{{ callData.ucid }}</span>
    </div>
  </div> -->
  <!-- Primary Call Controls -->
  <div class="call-controls">
    @if (isCentroDialer && centroSipRinging) {
      <div class="control-btn-wrapper">
        <button class="control-btn answer" (click)="answerCentroSipCall()">
          <mat-icon>call</mat-icon>
        </button>
        <span class="control-label">Answer</span>
      </div>
    }
    @if (isCentroDialer && centroSipRinging) {
      <div class="control-btn-wrapper">
        <button class="control-btn end-call" (click)="rejectCentroSipCall()">
          <mat-icon>call_end</mat-icon>
        </button>
        <span class="control-label">Reject</span>
      </div>
    }
    @if (isCubeWebphone && isCubeAgentRinging) {
      <div class="control-btn-wrapper">
        <button class="control-btn answer" (click)="answerCubeCall()">
          <mat-icon>call</mat-icon>
        </button>
        <span class="control-label">Answer</span>
      </div>
    }
    @if (isCubeWebphone && isCubeAgentRinging) {
      <div class="control-btn-wrapper">
        <button class="control-btn end-call" (click)="endCall()">
          <mat-icon>call_end</mat-icon>
        </button>
        <span class="control-label">End</span>
      </div>
    }
    <!-- End Call Button (when on call) -->
    @if (isOnCall && !isCubeAgentRinging) {
      <div class="control-btn-wrapper">
        <button class="control-btn end-call" (click)="endCall()"
          [disabled]="inputObj.Status !== 'CONNECTED' && inputObj.Status !== 'CALLING'">
          <mat-icon>call_end</mat-icon>
        </button>
        <span class="control-label">End</span>
      </div>
    }
    <!-- Hold/Unhold -->
    @if (isOnCall && !isCubeAgentRinging) {
      <div class="control-btn-wrapper">
        <button class="control-btn hold" [class.active]="inputObj.holdCall"
          (click)="inputObj.holdCall ? unholdCall() : holdCall()" [disabled]="inputObj.Status !== 'CONNECTED'">
          <mat-icon>{{ inputObj.holdCall ? 'play_arrow' : 'pause' }}</mat-icon>
        </button>
        <span class="control-label">{{ inputObj.holdCall ? 'Resume' : 'Hold' }}</span>
      </div>
    }
    <!-- Mute/Unmute -->
    @if (isOnCall && !isCubeAgentRinging) {
      <div class="control-btn-wrapper">
        <button class="control-btn mute" [class.active]="isMuted" (click)="toggleMute()"
          [disabled]="inputObj.Status !== 'CONNECTED'">
          <mat-icon>{{ isMuted ? 'mic_off' : 'mic' }}</mat-icon>
        </button>
        <span class="control-label">{{ isMuted ? 'Unmute' : 'Mute' }}</span>
      </div>
    }
    <!-- Warm transfer to another agent -->
    @if (isOnCall && isSdkDialer) {
      <div class="control-btn-wrapper">
        <button class="control-btn transfer" [class.active]="inputObj.transferCall"
          [matMenuTriggerFor]="transferMenu" [disabled]="inputObj.Status !== 'CONNECTED'">
          <mat-icon>phone_forwarded</mat-icon>
        </button>
        <span class="control-label">Transfer</span>
      </div>
    }
    <!-- Dialpad Toggle -->
    <!-- <div class="control-btn-wrapper">
    <button class="control-btn dialpad" [class.active]="showDialpad" (click)="toggleDialpad()">
      <mat-icon>dialpad</mat-icon>
    </button>
    <span class="control-label">Dialpad</span>
  </div> -->
  <!-- Dispose — re-enable when disposition flow is needed
  <div class="control-btn-wrapper" *ngIf="isCubeWebphone && isOnCall">
    <button class="control-btn dispose" (click)="disposeCubeCall()">
      <mat-icon>assignment_turned_in</mat-icon>
    </button>
    <span class="control-label">Dispose</span>
  </div>
  -->
  @if (isCubeWebphone && isOnCall && !isCubeAgentRinging) {
    <div class="control-btn-wrapper">
      <button class="control-btn transfer" (click)="toggleCubeTools()" title="Transfer / Conference / Merge">
        <mat-icon>phone_forwarded</mat-icon>
      </button>
      <span class="control-label">More</span>
    </div>
  }
  <!-- <div class="control-btn-wrapper" *ngIf="isCentroDialer && isOnCall && !centroSipRinging">
  <button class="control-btn transfer" (click)="toggleCentroTools()" title="Transfer / Conference / Merge">
    <mat-icon>phone_forwarded</mat-icon>
  </button>
  <span class="control-label">More</span>
</div> -->
<!-- Go To Case (connected call with case context only) -->
<!-- <div class="control-btn-wrapper" *ngIf="showGotoCase && inputObj.dueId && (!isCentroDialer || inputObj.Status === 'CONNECTED')">
<button class="control-btn goto-case" (click)="gotToTimeline()">
  <mat-icon>open_in_new</mat-icon>
</button>
<span class="control-label">Case</span>
</div> -->
<!-- Break Menu -->
<!-- <div class="control-btn-wrapper" *ngIf="!isOnCall">
<button class="control-btn break" [class.active]="isBreakActive" [matMenuTriggerFor]="breakMenu"
  *ngIf="!isBreakActive">
  <mat-icon>free_breakfast</mat-icon>
</button>
<button class="control-btn break active" (click)="resumeCall()" *ngIf="isBreakActive">
  <mat-icon>play_circle</mat-icon>
</button>
<span class="control-label">{{ isBreakActive ? (inputObj.breakValue || 'On Break') : 'Break' }}</span>
</div> -->
</div>
<!-- Break Menu -->
<mat-menu #breakMenu="matMenu" class="break-menu">
  @for (breakType of activeBreakTypes; track breakType) {
    <button mat-menu-item (click)="pauseAPICall(breakType.name)">
      <mat-icon>{{ getBreakIcon(breakType.name) }}</mat-icon>
      <span>{{ breakType.name }}</span>
    </button>
  }
</mat-menu>
@if (isCubeWebphone && showCubeTools && showBody) {
  <div class="dialpad-panel cube-tools-panel">
    <div class="dialpad-panel-header">
      <span class="dialpad-panel-title">Call actions</span>
      <button type="button" class="dialpad-close-btn" (click)="toggleCubeTools()" title="Close">
        <mat-icon>close</mat-icon>
        <span>Close</span>
      </button>
    </div>
    <!-- Conference tab is disabled because it's not working -->
    <!-- <div class="cube-tools-tabs">
    <button type="button" class="cube-tools-tab" [class.active]="cubeToolsTab === 'transfer'"
      (click)="setCubeToolsTab('transfer')">
      Transfer
    </button>
    <button type="button" class="cube-tools-tab" [class.active]="cubeToolsTab === 'conference'"
      (click)="setCubeToolsTab('conference')">
      Conference
    </button>
  </div> -->
  @if (cubeToolsTab === 'transfer') {
    <div class="cube-tools-section">
      <div class="cube-tools-section-head">
        <span>Transfer to agent (your campaign)</span>
        <button type="button" class="cube-tools-refresh" (click)="refreshCubeTransferAgents()"
          [disabled]="cubeTransferAgentsLoading" title="Refresh agents from Cube">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
      <mat-form-field appearance="outline" class="cube-agent-select">
        <mat-label>Agent ID</mat-label>
        <mat-select [(ngModel)]="cubeSelectedTransferAgent" [disabled]="!isCubeTransferMergeEnabled">
          @for (agent of cubeTransferAgents; track agent) {
            <mat-option [value]="agent.AgentId">
              {{ agent.label || agent.AgentId }}@if (agent.Extension) {
              <span> · {{ agent.Extension }}</span>
            }
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (cubeTransferAgentsLoading) {
      <p class="cube-tools-hint">Loading agents from Cube…</p>
    }
    @if (!cubeTransferAgentsLoading && !cubeTransferAgents.length) {
      <p class="cube-tools-hint">
        No idle agents on your campaign right now (logged-in Idle agents only).
      </p>
    }
    <button type="button" class="action-btn primary full-width" (click)="transferCubeCall()"
      [disabled]="!isCubeTransferMergeEnabled || !cubeSelectedTransferAgent || cubeTransferAgentsLoading">
      Transfer call
    </button>
  </div>
}
@if (cubeToolsTab === 'conference') {
  <div class="cube-tools-section">
    <div class="cube-conf-steps">
      <span class="cube-conf-step" [class.done]="isCubeConferenceMergeReady">1. Dial 3rd party</span>
      <span class="cube-conf-step" [class.active]="isCubeConferenceMergeReady">2. Merge</span>
    </div>
    @if (cubeConferenceBlockedReason) {
      <p class="cube-tools-hint cube-tools-warn">
        {{ cubeConferenceBlockedReason }}
      </p>
    }
    <label class="cube-tools-field">
      <span>3rd party number</span>
      <input type="tel" [(ngModel)]="cubeConferenceNumber" maxlength="10" placeholder="10-digit mobile"
        class="dialpad-input-field" [disabled]="!isCubeTransferMergeEnabled" />
    </label>
    <div class="cube-conf-dialpad">
      @for (key of dialpadKeys; track key) {
        <button type="button" class="dialpad-key"
          (click)="onCubeConferenceKey(key)" [disabled]="!isCubeTransferMergeEnabled">
          {{ key }}
        </button>
      }
    </div>
    <div class="cube-conf-actions">
      <button type="button" class="action-btn" (click)="conferenceCubeCall()"
        [disabled]="!isCubeTransferMergeEnabled || cubeConferenceNumber.length < 10 || !!cubeConferenceBlockedReason">
        Dial 3rd party
      </button>
      <button type="button" class="action-btn primary" (click)="mergeCubeCall()"
        [disabled]="!isCubeTransferMergeEnabled || !isCubeConferenceMergeReady">
        Merge call
      </button>
    </div>
    @if (!isCubeConferenceMergeReady) {
      <p class="cube-tools-hint">
        Dial the 3rd party first. When they answer, tap Merge call.
      </p>
    }
    @if (isCubeConferenceMergeReady) {
      <p class="cube-tools-hint success">
        3rd party dial sent — merge when they are on the line.
      </p>
    }
  </div>
}
<!-- Disposition UI disabled for now
<div class="cube-tools-footer">
  <label class="cube-tools-field compact">
    <span>Disposition</span>
    <input type="text" [(ngModel)]="cubeDisposition" class="dialpad-input-field" />
  </label>
  <button type="button" class="action-btn" (click)="disposeCubeCall()" [disabled]="!isCubeTransferMergeEnabled">
    Dispose
  </button>
</div>
-->
</div>
}
@if (isCubeWebphone && showCubeManualDial) {
  <div class="dialpad-panel sdk-manual-dial-panel">
    <div class="dialpad-panel-header">
      <span class="dialpad-panel-title">Manual Dial</span>
    </div>
    <div class="dialpad-input">
      <input type="tel" [(ngModel)]="dialpadNumber" placeholder="Enter number to dial"
        class="dialpad-input-field" />
      <button class="dial-btn" (click)="makeManualCall()" [disabled]="!dialpadNumber || isOnCall">
        <mat-icon>call</mat-icon>
      </button>
    </div>
    <div class="dialpad-grid">
      @for (key of dialpadKeys; track key) {
        <button class="dialpad-key" (click)="onDialpadKey(key)">
          {{ key }}
        </button>
      }
    </div>
    <div class="dialpad-actions">
      <button class="action-btn clear" (click)="dialpadNumber = ''">
        <mat-icon>backspace</mat-icon>
        Clear
      </button>
    </div>
  </div>
}
<mat-menu #transferMenu="matMenu" class="transfer-menu" (menuOpened)="onTransferMenuOpened()">
  <div class="transfer-menu-content" (click)="$event.stopPropagation()">
    <div class="transfer-menu-header">
      <mat-icon>phone_forwarded</mat-icon>
      <div class="transfer-menu-heading">
        <span class="transfer-menu-title">Transfer call</span>
        <span class="transfer-menu-subtitle">Choose an online agent</span>
      </div>
    </div>
    <div class="transfer-search-wrap">
      <mat-icon class="transfer-search-icon">search</mat-icon>
      <input class="transfer-search-input" type="text" name="transferAgentSearch"
        [(ngModel)]="transferAgentSearch" placeholder="Search agent..." autocomplete="off"
        (keydown)="$event.stopPropagation()" />
    </div>
    @if (filteredTransferAgents.length > 0) {
      <div class="transfer-agent-list">
        @for (agent of filteredTransferAgents; track agent) {
          <button type="button" class="transfer-agent-item"
            [class.selected]="isTransferAgentSelected(agent)" (click)="selectTransferAgent(agent)">
            <span class="transfer-agent-name">{{ agent.label || agent.AgentId }}</span>
            @if (isTransferAgentSelected(agent)) {
              <mat-icon>check</mat-icon>
            }
          </button>
        }
      </div>
    }
    @if (extensionNumbers.length === 0) {
      <p class="transfer-empty-hint">No online agents available</p>
    }
    @if (extensionNumbers.length > 0 && filteredTransferAgents.length === 0) {
      <p class="transfer-empty-hint">
        No agents match your search
      </p>
    }
    <button mat-flat-button class="transfer-confirm-btn" (click)="transferCall()"
      [disabled]="!inputObj.RedirectToAgentId || extensionNumbers.length === 0 || loader">
      @if (!loader) {
        <mat-icon>phone_forwarded</mat-icon>
      }
      {{ loader ? 'Transferring...' : 'Transfer' }}
    </button>
  </div>
</mat-menu>
<!-- Dialpad Panel -->
@if (showDialpad) {
  <div class="dialpad-panel">
    <div class="dialpad-input">
      <input type="tel" [(ngModel)]="dialpadNumber" placeholder="Enter number to dial"
        class="dialpad-input-field" />
      <button class="dial-btn" (click)="makeManualCall()" [disabled]="!dialpadNumber || isOnCall">
        <mat-icon>call</mat-icon>
      </button>
    </div>
    <div class="dialpad-grid">
      @for (key of dialpadKeys; track key) {
        <button class="dialpad-key" (click)="onDialpadKey(key)">
          {{ key }}
        </button>
      }
    </div>
    <div class="dialpad-actions">
      <button class="action-btn clear" (click)="dialpadNumber = ''">
        <mat-icon>backspace</mat-icon>
        Clear
      </button>
    </div>
  </div>
}
@if (isCentroDialer && showCentroManualDial) {
  <div class="dialpad-panel sdk-manual-dial-panel">
    <div class="dialpad-panel-header">
      <span class="dialpad-panel-title">Manual Dial</span>
    </div>
    <div class="dialpad-input">
      <input type="tel" [(ngModel)]="dialpadNumber" placeholder="Enter number to dial"
        class="dialpad-input-field" />
      <button class="dial-btn" (click)="centroManualDialCall()" [disabled]="!dialpadNumber || isOnCall">
        <mat-icon>call</mat-icon>
      </button>
    </div>
    <div class="dialpad-grid">
      @for (key of dialpadKeys; track key) {
        <button class="dialpad-key" (click)="onDialpadKey(key)">
          {{ key }}
        </button>
      }
    </div>
    <div class="dialpad-actions">
      <button class="action-btn clear" (click)="dialpadNumber = ''">
        <mat-icon>backspace</mat-icon>
        Clear
      </button>
    </div>
  </div>
}
@if (isCentroDialer && showCentroTools && showBody) {
  <div class="dialpad-panel cube-tools-panel">
    <div class="dialpad-panel-header">
      <span class="dialpad-panel-title">Call actions</span>
      <button type="button" class="dialpad-close-btn" (click)="toggleCentroTools()" title="Close">
        <mat-icon>close</mat-icon>
        <span>Close</span>
      </button>
    </div>
    <div class="cube-tools-tabs">
      <button type="button" class="cube-tools-tab" [class.active]="centroToolsTab === 'transfer'"
        (click)="setCentroToolsTab('transfer')">
        Transfer
      </button>
      <button type="button" class="cube-tools-tab" [class.active]="centroToolsTab === 'conference'"
        (click)="setCentroToolsTab('conference')">
        Conference
      </button>
    </div>
    @if (centroToolsTab === 'transfer') {
      <div class="cube-tools-section">
        <div class="cube-tools-section-head">
          <span>Transfer to agent</span>
          <button type="button" class="cube-tools-refresh" (click)="refreshCentroTransferAgents()"
            [disabled]="centroTransferAgentsLoading" title="Refresh agents">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
        <mat-form-field appearance="outline" class="cube-agent-select">
          <mat-label>Agent ID</mat-label>
          <mat-select [(ngModel)]="centroSelectedTransferAgent" [disabled]="!isCentroTransferEnabled">
            @for (agent of centroTransferAgents; track agent) {
              <mat-option [value]="agent.AgentId">
                {{ agent.label || agent.AgentId }}@if (agent.Extension) {
                <span> · {{ agent.Extension }}</span>
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (centroTransferAgentsLoading) {
        <p class="cube-tools-hint">Loading agents…</p>
      }
      @if (!centroTransferAgentsLoading && !centroTransferAgents.length) {
        <p class="cube-tools-hint">
          No agents available for transfer right now.
        </p>
      }
      <button type="button" class="action-btn primary full-width" (click)="transferCentroCall()"
        [disabled]="!isCentroTransferEnabled || !centroSelectedTransferAgent || centroTransferAgentsLoading">
        Transfer call
      </button>
    </div>
  }
  @if (centroToolsTab === 'conference') {
    <div class="cube-tools-section">
      <div class="cube-conf-steps">
        <span class="cube-conf-step" [class.done]="isCentroConferenceMergeReady">1. Dial 3rd party</span>
        <span class="cube-conf-step" [class.active]="isCentroConferenceMergeReady">2. Merge</span>
      </div>
      <label class="cube-tools-field">
        <span>3rd party number</span>
        <input type="tel" [(ngModel)]="centroConferenceNumber" maxlength="10" placeholder="10-digit mobile"
          class="dialpad-input-field" [disabled]="!isCentroTransferEnabled" />
      </label>
      <div class="cube-conf-dialpad">
        @for (key of dialpadKeys; track key) {
          <button type="button" class="dialpad-key"
            (click)="onCentroConferenceKey(key)" [disabled]="!isCentroTransferEnabled">
            {{ key }}
          </button>
        }
      </div>
      <div class="cube-conf-actions">
        <button type="button" class="action-btn" (click)="conferenceCentroCall()"
          [disabled]="!isCentroTransferEnabled || centroConferenceNumber.length < 10">
          Dial 3rd party
        </button>
        <button type="button" class="action-btn primary" (click)="mergeCentroCall()"
          [disabled]="!isCentroTransferEnabled || !isCentroConferenceMergeReady">
          Merge call
        </button>
      </div>
    </div>
  }
</div>
}
@if (isSdkDialer && showSdkManualDial) {
  <div class="dialpad-panel sdk-manual-dial-panel">
    <div class="dialpad-input">
      <input type="tel" [(ngModel)]="sdkDialNumber" placeholder="Enter number to dial"
        class="dialpad-input-field" />
      <button class="dial-btn" (click)="sdkManualDialCall()" [disabled]="!sdkDialNumber || isOnCall">
        <mat-icon>call</mat-icon>
      </button>
    </div>
    <div class="dialpad-grid">
      @for (key of dialpadKeys; track key) {
        <button class="dialpad-key" (click)="onSdkDialKey(key)">
          {{ key }}
        </button>
      }
    </div>
    <div class="dialpad-actions">
      <button class="action-btn clear" (click)="sdkDialNumber = ''">
        <mat-icon>backspace</mat-icon>
        Clear
      </button>
    </div>
  </div>
}
<!-- Agent State Selector — keep visible during Cube/Centro wrap-up so Set Break / Manual Dial remain usable -->
@if (!isOnCall && !isCubeAgentRinging && !isCubeConnecting && !isCubeAutoTransferRouting && !centroAutoTransferRouting && !showDialpad && !showSdkManualDial && !showCubeTools && !showCentroTools && !showOzonetelDispositionPanel) {
  <div class="agent-state-section">
    <div class="mt-action-btn-wrapper">
      @if (isCentroDialer && !isOnCall) {
        <div class="mt-btn-style">
          <mt-btn class="circle medium warning" [class.active]="showCentroManualDial"
            [disabled]="centroWrapUpActive"
            (onAction)="toggleCentroManualDial()">
            <img src="../../../../assets/icons/goto_case.svg" alt="" width="50" height="50" />
          </mt-btn>
          <p>Manual Dial</p>
        </div>
      }
      @if (isSdkDialer) {
        <div class="mt-btn-style">
          <mt-btn class="circle medium warning" [class.active]="showSdkManualDial" (onAction)="toggleSdkManualDial()">
            <img src="../../../../assets/icons/goto_case.svg" alt="" srcset="" />
          </mt-btn>
          <p>manual-dial</p>
        </div>
      }
      @if (isCubeWebphone) {
        <div class="mt-btn-style">
          <mt-btn class="circle medium warning" [class.active]="showCubeManualDial" (onAction)="toggleCubeManualDial()">
            <img src="../../../../assets/icons/goto_case.svg" alt="" srcset="" />
          </mt-btn>
          <p>manual-dial</p>
        </div>
      }
      @if (!isSdkDialer && !isCubeWebphone && !isCentroDialer) {
        <div class="mt-btn-style">
          @if (showGotoCase && inputObj.dueId) {
            <mt-btn class="circle medium warning" (onAction)="gotToTimeline()">
              <img src="../../../../assets/icons/goto_case.svg" alt="" srcset="" />
            </mt-btn>
          }
          @if (!showGotoCase || !inputObj.dueId) {
            <mt-btn class="circle medium warning">
              <img src="../../../../assets/icons/goto_case_disabled.svg" alt="" srcset="" width="50px" height="50px" />
            </mt-btn>
          }
          <p>Go To Case</p>
        </div>
      }
      <div class="mt-btn-style">
        @if (!inputObj.holdCall) {
          <mt-btn class="circle medium yellow" [disabled]="!(inputObj.Status === 'CONNECTED')" (onAction)="holdCall()"
            >
              <img [src]="
                  !(inputObj.Status === 'CONNECTED')
                    ? '../../../../assets/icons/disable_hold.svg'
                    : '../../../../assets/icons/call_hold.svg'
                " alt="call_hold" srcset="" width="50px" height="50px" />
          </mt-btn>
        }
        @if (inputObj.holdCall) {
          <mt-btn class="circle medium" (onAction)="unholdCall()">
            <img src="../../../../assets/icons/call_unhold.svg" alt="call_unhold" srcset="" width="50px"
              height="50px" />
          </mt-btn>
        }
        @if (!inputObj.holdCall) {
          <p>Hold</p>
        }
        @if (inputObj.holdCall) {
          <p>Unhold</p>
        }
      </div>
      <!-- <div class="mt-btn-style">
      <mt-btn class="circle medium info" (onAction)="setAgentReady()"
        [disabled]="agentStatus === 'IDLE' || agentStatus === 'BUSY'" *ngIf="agentStatus !== 'IDLE'">
        <mat-icon
        style="color: white; font-size: 24px; width: 24px; height: 24px;">radio_button_unchecked</mat-icon>
      </mt-btn>
      <mt-btn class="circle medium info" [disabled]="true" *ngIf="agentStatus === 'IDLE'">
        <mat-icon style="color: white; font-size: 24px; width: 24px; height: 24px;">check_circle</mat-icon>
      </mt-btn>
      <p>Go Ready</p>
    </div> -->
    <div class="mt-btn-style">
      @if (!isBreakActive) {
        <mt-btn [matMenuTriggerFor]="breakMenu"
          [disabled]="inputObj.Status == 'CONNECTED' || inputObj.Status == 'CALLING'"
          class="circle medium info">
              <img [src]="
                  inputObj.Status == 'CONNECTED' || inputObj.Status == 'CALLING'
                    ? '../../../../assets/icons/callbreak_diable.svg'
                    : '../../../../assets/icons/call_break.svg'
                " height="50" width="50" alt="call_break" />
        </mt-btn>
      }
      @if (isBreakActive) {
        <mt-btn (onAction)="resumeCall()" class="circle medium info">
          <img src="../../../../assets/icons/call_unbreak.svg" height="50" width="50" alt="call_unbreak" />
        </mt-btn>
      }
      @if (!isBreakActive) {
        <p>Set Break</p>
      }
      @if (isBreakActive) {
        <p>{{ inputObj.breakValue || 'On Break' }}</p>
      }
    </div>
    <mat-menu #breakMenu="matMenu" class="custom-menu">
      @for (break of activeBreakTypes; track break) {
        <button mat-menu-item (click)="pauseAPICall(break.name)">
          <span class="break-menu-item">
            @if (isBreakActive && inputObj.breakValue === break.name) {
              <mat-icon>check</mat-icon>
            }
            {{ break.name }}
          </span>
        </button>
      }
    </mat-menu>
  </div>
</div>
}
</div>
}

<!-- Collapsed View -->
@if (!fullScreen) {
  <div class="collapsed-content">
    <div class="collapsed-info">
      <span class="collapsed-status">{{ getStatusText() }}</span>
      @if (inputObj.phoneNo) {
        <span class="collapsed-number">{{ inputObj.phoneNo }}</span>
      }
    </div>
    @if (isOnCall) {
      <div class="collapsed-actions">
        <button class="mini-btn end" (click)="endCall()">
          <mat-icon>call_end</mat-icon>
        </button>
        <button class="mini-btn" [class.active]="inputObj.holdCall"
          (click)="inputObj.holdCall ? unholdCall() : holdCall()">
          <mat-icon>{{ inputObj.holdCall ? 'play_arrow' : 'pause' }}</mat-icon>
        </button>
        <button class="mini-btn" [class.active]="isMuted" (click)="toggleMute()">
          <mat-icon>{{ isMuted ? 'mic_off' : 'mic' }}</mat-icon>
        </button>
        @if (isSdkDialer) {
          <button class="mini-btn transfer-mini" [matMenuTriggerFor]="transferMenu"
            [disabled]="inputObj.Status !== 'CONNECTED'">
            <mat-icon>phone_forwarded</mat-icon>
          </button>
        }
      </div>
    }
  </div>
}
</div>